import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Input,
  Col,
  Modal,
    ModalBody 
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { reportmanageService } from "../../../services/reportmanageService";
import { usermanageService } from "../../../services/usermanageService";
import { taskmanageService } from "../../../services/taskmanageService";

const QAJobsReport = () => {
  const [reportData, setReportData] = useState([]);
  const [uniqueClients, setUniqueClients] = useState([]);
  const [uniqueTeamMembers, setUniqueTeamMembers] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [loading, setLoading] = useState(false);

  const [clientdetails,setclientdetails] = useState({});
  const [clientdetailPopup,setclientdetailPopup] = useState(false);
  const [date_change, setDate_change] = useState("due_within_3_days");

  // ✅ Fetch clients for dropdown
  const getClientList = async () => {
    try {
      const response = await usermanageService.getclient();
      if (response?.data?.clients) setUniqueClients(response.data.clients);
    } catch (error) {
      console.error("Error loading clients:", error);
    }
  };
  const getTeamList = async () => {
    try {
      const response = await taskmanageService.get_qa_analystteamleaderlist();
      if (response?.data?.tm) setUniqueTeamMembers(response.data.tm);
    } catch (error) {
      console.error("Error loading teams:", error);
    }
  };

  // ✅ Fetch report
  const getReportData = async (client = "", team_member = "",status="",date_change="due_within_3_days",type="") => {
    try {
      setLoading(true);
  const payload = { client, team_member, status,type };
  // If date_change is provided (non-empty), include it; otherwise omit to fetch all dates
  if (date_change) payload.date_change = date_change;
  const response = await reportmanageService.getUserwiseReport(payload,sortfield,sortorder);

      if (response.status === 200 && response.data.status) {
        setReportData(response.data.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching QA Jobs report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };
    // sorting functon
    const [sortfield,setsortfield] = useState('');
    const [sortorder,setsortorder] = useState('asc');
    function sortTable(field){
      console.log(field)
      setsortfield(field);
      if(sortorder=='asc'){
        setsortorder('desc');
      }else{
        setsortorder('asc');
      }
    }
    useEffect(() => {
    
    getReportData();
    
  }, [sortorder]);

  // 🚀 Initial load
  useEffect(() => {
    getClientList();
    getReportData();
    getTeamList();
    get_status_list()
  }, []);

  // 🔄 Handle client/team filters
  const handleClientChange = (e) => {
    const val = e.target.value;
    setSelectedClient(val);
    getReportData(val, selectedTeam,selectedStatus,date_change,selectedType);
  };

  const handleTeamChange = (e) => {
    const val = e.target.value;
  
    setSelectedTeam(val);
    getReportData(selectedClient, val,selectedStatus,date_change,selectedType);
  };
  const handleStatusChange = (e) => {
    const val = e.target.value;
  
    setSelectedStatus(val);
    getReportData(selectedClient, selectedTeam,val,date_change,selectedType);
  };
  const handleTypeChange = (e) => {
    const val = e.target.value;
  
    setSelectedType(val);
    getReportData(selectedClient, selectedTeam,selectedStatus,date_change,val);
  };
  

  const handleDateChange = (e) => {
    const val = e.target.value;
  
    setDate_change(val);
    getReportData(selectedClient, selectedTeam,selectedStatus, val,selectedType);
  };

  // 🎨 Color for overdue / due soon / completed
  const getRowStyle = (colorCode) => {
    if (colorCode === "Red") return { backgroundColor: "#ffe6e6" };
    if (colorCode === "Yellow") return { backgroundColor: "#fff7e6" };
    if (colorCode === "Green") return { backgroundColor: "#e6ffe6" };
    return {};
  };
const downloadReport = () => {
    // const [year, month] = filterMonth.split("-");
    // const lastDay = new Date(year, month, 0).getDate();
    // const startDate = `${year}-${month}-01`;
    // const endDate = `${year}-${month}-${String(lastDay).padStart(2, "0")}`; 

    reportmanageService.getUserwiseReportExport( selectedClient, selectedTeam,selectedStatus,date_change,selectedType);
  };
const handleClick = (status, ageing) => {
    reportmanageService.taskdetails(status, ageing).then((response) => {
      setclientdetails(response.data.data);
      setclientdetailPopup(!clientdetailPopup);
    });
};
  const [statuslist, setStatusdata] = useState([]);
  function get_status_list() {
    taskmanageService.getstatus().then((response) => {
      setStatusdata(response.data.status);
    });
  }
  console.log(statuslist)
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mb-3">
          <Col>
            <h2>QA Jobs Status Report</h2>
          </Col>
        </Row>

        <Card className="shadow">
          <CardHeader className="d-flex flex-wrap ">
            {/* Client Filter */}
            <div className="col-md-2 mb-2">
              <select
                className="form-control"
                onChange={handleClientChange}
                value={selectedClient}
              >
                <option value="">All Clients</option>
                {uniqueClients.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Team Filter */}
            <div className="col-md-2 mb-2">
               <select
                className="form-control"
                onChange={handleTeamChange}
                value={selectedTeam}
              >
                <option value="">Team member</option>
                {uniqueTeamMembers.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2 mb-2">
               <select
                className="form-control"
                onChange={handleDateChange}
                value={date_change}
              >
                <option value="">All</option>
                <option value="due_within_3_days">Due within 3 days</option>
                <option value="due_4_5_days">Due 4-5 days</option>
                <option value="due_more_than_5_days">Due more than 5 days</option>
              </select>
            </div>
            <div className="col-md-2 mb-2">
               <select
                className="form-control"
                onChange={handleTypeChange}
               
              >
                <option value="">Select Type</option>
                <option value="Outsource">Outsource</option>
                <option value="Offshore">Offshore</option>
                </select>
            </div>
             <div className="col-md-2 mb-2">
               <select
                                            
                                               className="form-control"
                                               onChange={handleStatusChange}
                                             >
                                               <option value="0" key="0" style={{background:'#fff',color:'#000'}}>Select Status</option>
                                               {statuslist &&
                                               statuslist.length &&
                                               statuslist != null ? (
                                                 statuslist.map((status) =>
                                                 
                                                     <option key={status.id} value={status.id} >
                                                       {status.name}
                                                     </option>
                                                 )
                                               ) : (
                                                 <option>No data Found</option>
                                               )}
                                             </select>
            </div>
 <Col xs={2}>
                                  <div className="col-xl-12 col-md-12 col-xs-12 ">
                                    <Button
                                      className="btn-icon-clipboard"
                                      type="button"
                                      onClick={(e)=>downloadReport()}
                                      title="Download Report"
                                    >
                                      <i className="fas fa-download" style={{ fontSize: '14px' }}></i> Export
                                    </Button>
                                  </div>
                                  </Col>
            
          </CardHeader>

          <Table className="align-items-center table-flush" responsive bordered>
            <thead className="thead-light">
              <tr>
                <th>Team Member</th>
                <th>Total Jobs</th>
                <th>Completed</th>
                <th>In Progress</th>
                <th>Not Started</th>
                <th>Under Review</th>
                <th>On Hold</th>
                <th>Overdue</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">Loading...</td>
                </tr>
              ) : reportData.length > 0 ? (
                reportData.map((member, i) => (
                  <React.Fragment key={i}>
                    {/* Summary Row */}
                    <tr style={{ backgroundColor: "#f3f4f6", fontWeight: "bold" }}>
                      <td>{member.team_member}</td>
                      <td >{member.total_jobs || 0}</td>
                      <td>{member.completed || 0}</td>
                      <td >{member.in_progress || 0}</td>
                      <td >{member.not_started || 0}</td>
                      <td >{member.under_review || 0}</td>
                      <td >{member.on_hold || 0}</td>
                      <td >{member.overdue || 0}</td>
                    </tr>

                    {/* Overdue/Due Soon Jobs */}
                    {member.jobs && member.jobs.length > 0 && (
                      <>
                        <tr>
                          <th colSpan="8" style={{ background: "#edf2f7" }}>
                            <strong>Overdue / Due Soon Jobs</strong>
                          </th>
                        </tr>
                        <tr style={{ background: "#fafafa" }}>
                          <th className="sortclass" onClick={(e) => sortTable('company_name')}>Client Name</th>
                          <th>Sub client</th>
                          <th >Type</th>
                          <th className="sortclass" onClick={(e) => sortTable('status_name')}>Status</th>
                          <th>QA Start Date</th>
                          <th className="sortclass" onClick={(e) => sortTable('due_date')}>Due Date</th>
                          <th>Days Left</th>
                          <th>Remarks</th>
                        </tr>
                        {member.jobs.map((job, j) => (
                          <tr key={j} style={getRowStyle(job.color_code)}>
                         
                            <td>{job.company_name}</td>
                            <td>{job.sub_client}</td>
                            <td>{job.type}</td>
                            <td>{job.status_name}</td>
                            <td>{job.created_at || "-"}</td>
                            <td>{job.due_date ? new Date(job.due_date).toLocaleDateString() : "-"}</td>
                            <td>{job.days_label}</td>
                            <td>{job.remarks}</td>
                          </tr>
                        ))}
                      </>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No Data Found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
        <Modal
                    size="lg"
                    className="taskdetailmodal"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    toggle={() => setclientdetailPopup(!clientdetailPopup)}
                    isOpen={clientdetailPopup}
                  >
                    <div className="modal-header">
                    <h3>Client Details</h3>
                      <button
                        aria-label="Close"
                        className=" close"
                        type="button"
                        onClick={() => setclientdetailPopup(false)}
                      >
                        <span aria-hidden={true}>×</span>
                      </button>
                    </div>
                    <ModalBody style={{paddingTop:'0px'}}>
                  
                      <Table>
                        <thead>
                          <tr>
                            <th className="whitespace">Client Name</th>
                            <th className="whitespace">Sub Client Name</th>
                            <th className="whitespace">Status</th>
                            <th className="whitespace">Book Keeping software</th>
                            <th className="whitespace">Acc. prod. software</th>
                            <th className="whitespace">Type</th>
                            <th className="whitespace"> TL</th>
                            <th className="whitespace"> TM</th>
                            <th className="whitespace">Budgeted Hours</th>
                            <th className="whitespace">Year end Date</th>
                            <th className="whitespace">Job Received Date</th>
                            <th className="whitespace">Doc. Received Date</th>
                            <th className="whitespace">Due date</th>
                            <th className="whitespace">Job Completion Date</th> 
                            
                          </tr>
                        </thead>
                        <tbody>
                        {clientdetails && clientdetails.length
                                  ?                               
                                  clientdetails.map((client,d) => (
                                      <tr key={d} className={((d % 2 == 0)? 'purple-row': 'orange-row' )}>
                                        <td className="whitespace">{client.name}</td>
                                        <td  className="whitespace">{client.sub_client}</td>
                                        {inputFields.type == 'phases' ? 
                                        <td  className="whitespace">{client.phase_name}</td>
                                        : null }
                                        <td  className="whitespace">{client.status_name}</td>
                                        <td  className="whitespace">{client.book_keeping_software}</td>
                                        <td  className="whitespace">{client.account_prod_software}</td>
                                        <td  className="whitespace">{client.type}</td>
                                        <td  className="whitespace">{client.lead}</td>
                                        <td  className="whitespace">{client.member}</td>
                                        <td  className="whitespace">{client.budget}</td>
                                        <td  className="whitespace">{client.year_end_date}</td>
                                        <td  className="whitespace">{client.raised_date}</td>
                                        <td  className="whitespace">{client.doc_received_date}</td>
                                        <td  className="whitespace">{client.due_date}</td>
                                        <td  className="whitespace">{client.completed_date}</td>
                                        
                                      </tr>
                                    ))
                                  :
                                   ( <p>No Data Found</p> )}
                        </tbody>
                      </Table>
                    </ModalBody>
                   </Modal>
      </Container>
    </>
  );
};

export default QAJobsReport;
